export const periodicTable: any = {
  H: [1, 1, [1.007825032, 2.014101778], [0.999855, 0.000145]],
  He: [2, 0, [3.01602932, 4.002603254], [0.000002, 0.999998]],
  Li: [3, 1, [6.015122887, 7.01600344], [0.0485, 0.9515]],
  Be: [4, 2, [9.0121831], [1.0]],
  B: [5, 3, [10.012937, 11.009305], [0.1965, 0.8035]],
  C: [6, -4, [12, 13.00335484], [0.9894, 0.0106]],
  N: [7, 5, [14.003074, 15.0001089], [0.996205, 0.003795]],
  O: [8, -2, [15.99491462, 16.99913176, 17.99915961], [0.99757, 0.0003835, 0.002045]],
  F: [9, -1, [18.99840316], [1.0]],
  Ne: [10, 0, [19.99244018, 20.9938467, 21.9913851], [0.9048, 0.0027, 0.0925]],
  Na: [11, 1, [22.98976928], [1.0]],
  Mg: [12, 2, [23.9850417, 24.985837, 25.982593], [0.78965, 0.10011, 0.11025]],
  Al: [13, 3, [26.9815385], [1.0]],
  Si: [14, 4, [27.97692654, 28.97649467, 29.97377001], [0.922545, 0.04672, 0.030735]],
  P: [15, 5, [30.973762], [1.0]],
  S: [16, -2, [31.97207117, 32.97145891, 33.967867, 35.967081], [0.9485, 0.00763, 0.04365, 0.000158]],
  Cl: [17, -1, [34.9688527, 36.9659026], [0.758, 0.242]],
  Ar: [18, 0, [35.9675451, 37.962732, 39.96238312], [0.003336, 0.000629, 0.996035]],
  K: [19, 1, [38.96370649, 39.9639982, 40.96182526], [0.932581, 0.000117, 0.067302]],
  Ca: [
    20,
    2,
    [39.9625909, 41.958618, 42.958766, 43.955482, 45.95369, 47.9525228],
    [0.96941, 0.00647, 0.00135, 0.02086, 0.00004, 0.00187],
  ],
  Sc: [21, 3, [44.955908], [1.0]],
  Ti: [22, 4, [45.952628, 46.951759, 47.947942, 48.947866, 49.944787], [0.0825, 0.0744, 0.7372, 0.0541, 0.0518]],
  V: [23, 5, [49.947156, 50.943957], [0.0025, 0.9975]],
  Cr: [24, 2, [49.946042, 51.940506, 52.940648, 53.938879], [0.04345, 0.83789, 0.09501, 0.02365]],
  Mn: [25, 2, [54.938044], [1.0]],
  Fe: [26, 3, [53.939609, 55.934936, 56.935393, 57.933274], [0.05845, 0.91754, 0.02119, 0.00282]],
  Co: [27, 2, [58.933194], [1.0]],
  Ni: [
    28,
    2,
    [57.935342, 59.930786, 60.931056, 61.928345, 63.927967],
    [0.680769, 0.262231, 0.011399, 0.036345, 0.009256],
  ],
  Cu: [29, 2, [62.929598, 64.92779], [0.6915, 0.3085]],
  Zn: [30, 2, [63.929142, 65.926034, 66.927128, 67.924845, 69.92532], [0.4917, 0.2773, 0.0404, 0.1845, 0.0061]],
  Ga: [31, 3, [68.925574, 70.924703], [0.60108, 0.39892]],
  Ge: [32, 2, [69.924249, 71.9220758, 72.923459, 73.92117776, 75.9214027], [0.2052, 0.2745, 0.0776, 0.3652, 0.0775]],
  As: [33, 3, [74.921595], [1.0]],
  Se: [
    34,
    4,
    [73.9224759, 75.9192137, 76.9199142, 77.917309, 79.916522, 81.9167],
    [0.0086, 0.0923, 0.076, 0.2369, 0.498, 0.0882],
  ],
  Br: [35, -1, [78.918338, 80.91629], [0.5065, 0.4935]],
  Kr: [
    36,
    0,
    [77.920365, 79.916378, 81.913483, 82.914127, 83.91149773, 85.91061063],
    [0.00355, 0.02286, 0.11593, 0.115, 0.56987, 0.17279],
  ],
  Rb: [37, 1, [84.91178974, 86.90918053], [0.7217, 0.2783]],
  Sr: [38, 2, [83.913419, 85.909261, 86.908878, 87.905613], [0.0056, 0.0986, 0.07, 0.8258]],
  Y: [39, 3, [88.90584], [1.0]],
  Zr: [40, 4, [89.9047, 90.90564, 91.90503, 93.90631, 95.90827], [0.5145, 0.1122, 0.1715, 0.1738, 0.028]],
  Nb: [41, 5, [92.90637], [1.0]],
  Mo: [
    42,
    6,
    [91.906808, 93.905085, 94.905839, 95.904676, 96.906018, 97.905405, 99.907472],
    [0.14649, 0.09187, 0.15873, 0.16673, 0.09582, 0.24292, 0.09744],
  ],
  Tc: [43, 2, [97.90721], [1.0]],
  Ru: [
    44,
    3,
    [95.90759, 97.90529, 98.905934, 99.904214, 100.905577, 101.904344, 103.90543],
    [0.0554, 0.0187, 0.1276, 0.126, 0.1706, 0.3155, 0.1862],
  ],
  Rh: [45, 2, [102.9055], [1.0]],
  Pd: [
    46,
    2,
    [101.9056, 103.904031, 104.90508, 105.90348, 107.903892, 109.905172],
    [0.0102, 0.1114, 0.2233, 0.2733, 0.2646, 0.1172],
  ],
  Ag: [47, 1, [106.90509, 108.904755], [0.51839, 0.48161]],
  Cd: [
    48,
    2,
    [105.90646, 107.904183, 109.903007, 110.904183, 111.902763, 112.904408, 113.903365, 115.904763],
    [0.01245, 0.00888, 0.1247, 0.12795, 0.24109, 0.12227, 0.28754, 0.07512],
  ],
  In: [49, 3, [112.904062, 114.9038788], [0.04281, 0.95719]],
  Sn: [
    50,
    4,
    [
      111.904824, 113.902783, 114.9033447, 115.901743, 116.902954, 117.901607, 118.903311, 119.902202, 121.90344,
      123.905277,
    ],
    [0.0097, 0.0066, 0.0034, 0.1454, 0.0768, 0.2422, 0.0859, 0.3258, 0.0463, 0.0579],
  ],
  Sb: [51, 3, [120.90381, 122.90421], [0.5721, 0.4279]],
  Te: [
    52,
    4,
    [119.90406, 121.90304, 122.90427, 123.90282, 124.90443, 125.90331, 127.904461, 129.9062228],
    [0.0009, 0.0255, 0.0089, 0.0474, 0.0707, 0.1884, 0.3174, 0.3408],
  ],
  I: [53, -1, [126.90447], [1.0]],
  Xe: [
    54,
    0,
    [123.90589, 125.9043, 127.903531, 128.9047809, 129.9035094, 130.905084, 131.9041551, 133.905395, 135.9072145],
    [0.00095, 0.00089, 0.0191, 0.26401, 0.04071, 0.21232, 0.26909, 0.10436, 0.08857],
  ],
  Cs: [55, 1, [132.905452], [1.0]],
  Ba: [
    56,
    2,
    [129.90632, 131.905061, 133.904508, 134.905688, 135.904576, 136.905827, 137.905247],
    [0.0011, 0.001, 0.0242, 0.0659, 0.0785, 0.1123, 0.717],
  ],
  La: [57, 3, [137.90712, 138.90636], [0.0008881, 0.9991119]],
  Ce: [58, 3, [135.907129, 137.90599, 139.90544, 141.90925], [0.00186, 0.00251, 0.88449, 0.11114]],
  Pr: [59, 3, [140.90766], [1.0]],
  Nd: [
    60,
    3,
    [141.90773, 142.90982, 143.91009, 144.91258, 145.91312, 147.9169, 149.9209],
    [0.27153, 0.12173, 0.23798, 0.08293, 0.17189, 0.05756, 0.05638],
  ],
  Pm: [61, 3, [144.91276], [1.0]],
  Sm: [
    62,
    3,
    [143.91201, 146.9149, 147.91483, 148.91719, 149.91728, 151.91974, 153.92222],
    [0.0308, 0.15, 0.1125, 0.1382, 0.0737, 0.2674, 0.2274],
  ],
  Eu: [63, 3, [150.91986, 152.92124], [0.4781, 0.5219]],
  Gd: [
    64,
    3,
    [151.9198, 153.92087, 154.92263, 155.92213, 156.92397, 157.92411, 159.92706],
    [0.002, 0.0218, 0.148, 0.2047, 0.1565, 0.2484, 0.2186],
  ],
  Tb: [65, 4, [158.92535], [1.0]],
  Dy: [
    66,
    3,
    [155.92428, 157.92442, 159.9252, 160.92694, 161.92681, 162.92874, 163.92918],
    [0.00056, 0.00095, 0.02329, 0.18889, 0.25475, 0.24896, 0.2826],
  ],
  Ho: [67, 3, [164.93033], [1.0]],
  Er: [
    68,
    3,
    [161.92879, 163.92921, 165.9303, 166.93205, 167.93238, 169.93547],
    [0.00139, 0.01601, 0.33503, 0.22869, 0.26978, 0.1491],
  ],
  Tm: [69, 3, [168.93422], [1.0]],
  Yb: [
    70,
    3,
    [167.93389, 169.93477, 170.93633, 171.93639, 172.93822, 173.93887, 175.94258],
    [0.00126, 0.03023, 0.14216, 0.21754, 0.16098, 0.31896, 0.12887],
  ],
  Lu: [71, 3, [174.94078, 175.94269], [0.97401, 0.02599]],
  Hf: [
    72,
    4,
    [173.94005, 175.94141, 176.94323, 177.94371, 178.94582, 179.94656],
    [0.0016, 0.0526, 0.186, 0.2728, 0.1362, 0.3508],
  ],
  Ta: [73, 5, [179.94746, 180.948], [0.0001201, 0.9998799]],
  W: [74, 6, [179.94671, 181.948204, 182.950223, 183.950931, 185.95436], [0.0012, 0.265, 0.1431, 0.3064, 0.2843]],
  Re: [75, 2, [184.952955, 186.95575], [0.374, 0.626]],
  Os: [
    76,
    4,
    [183.952489, 185.95384, 186.95575, 187.95584, 188.95814, 189.95844, 191.96148],
    [0.0002, 0.0159, 0.0196, 0.1324, 0.1615, 0.2626, 0.4078],
  ],
  Ir: [77, 4, [190.96059, 192.96292], [0.373, 0.627]],
  Pt: [
    78,
    4,
    [189.95993, 191.96104, 193.962681, 194.964792, 195.964952, 197.96789],
    [0.00012, 0.00782, 0.32864, 0.33775, 0.25211, 0.07356],
  ],
  Au: [79, 3, [196.966569], [1.0]],
  Hg: [
    80,
    2,
    [195.96583, 197.966769, 198.968281, 199.968327, 200.970303, 201.970643, 203.973494],
    [0.0015, 0.1004, 0.1694, 0.2314, 0.1317, 0.2974, 0.0682],
  ],
  Tl: [81, 1, [202.972345, 204.974428], [0.29515, 0.70485]],
  Pb: [82, 2, [203.973044, 205.974466, 206.975897, 207.976653], [0.014, 0.241, 0.221, 0.524]],
  Bi: [83, 3, [208.9804], [1.0]],
  Po: [84, 4, [209], [1.0]],
  At: [85, 7, [210], [1.0]],
  Rr: [86, 0, [222], [1.0]],
  Fr: [87, 1, [223], [1.0]],
  Ra: [88, 2, [226], [1.0]],
  Ac: [89, 3, [227], [1.0]],
  Th: [90, 4, [230.03313, 232.03806], [0.0002, 0.9998]],
  Pa: [91, 4, [231.03588], [1.0]],
  U: [92, 6, [234.04095, 235.04393, 238.05079], [0.000054, 0.007204, 0.992742]],
  Ee: [0, 0, [0.000548597], [1.0]],
  D: [1, 1, [1.007825032, 2.014101778], [0.001, 0.999]],
}
